// 客户费率模板

import { HttpInboundOrderList, HttpAddInboundOrder, HttpExportInboundOrder, HttpCancelInboundOrder, HttpConfirmInboundOrder,HttpBatchConfirmInboundOrder } from '@/service/inbound';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
import compAdd from './add';
import mixin from '../mixin';
export default {
    mixins: [TableList, mixin],
    components: {
        compAdd
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpInboundOrderList,
        interceptRequest(data) {
            const warehouseId = data.search.warehouseId;
            data.warehouseId = warehouseId;
            delete data.search.warehouseId;
            return data
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case 'add':
                    this.operate = {
                        show: true,
                        title: this.$t('global.common.operation_add', { defaultValue: "添加" }),
                        width: 'large',
                        showFooter: false,
                        ajaxRequest: HttpAddInboundOrder,
                        component: "compAdd",
                    };
                    break;
                case 'query':
                    window.open(this.$router.resolve({
                        name: "inboundOrderDetail",
                        params: { type: "query" },
                        query: { id: params },
                    }).href, '_blank');
                    break;
                case 'edit':
                    window.open(this.$router.resolve({
                        name: "inboundOrderDetail",
                        params: { type: "edit" },
                        query: { id: params },
                    }).href, '_blank');
                    break;
                case "cancel":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: this.$t('global.common.operation_cancel', { defaultValue: "取消" }),
                        showDesc: false,
                        params: { inboundOrderId: params },
                        ajaxRequest: HttpCancelInboundOrder,
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                labelWidth: 'auto',
                                span: 24,
                                label: this.$t('fbb.headlogistics.cancel_reason', { defaultValue: "取消原因" })
                            }
                        ]
                    };
                    break;
                case "confirm":
                    this.operate = {
                        show: true,
                        alert: "success",
                        showDesc: false,
                        title: this.$t('global.datepicker.confirm', { defaultValue: "确认" }),
                        params: { inboundOrderId: params },
                        ajaxRequest: HttpConfirmInboundOrder,
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                labelWidth: 'auto',
                                span: 24,
                                label: this.$t('fbb.inbound.order_confirm_reason', { defaultValue: "确认原因" }),
                                required: false,
                            }
                        ]
                    };
                    break;
                case "batchConfirm":
                    this.operate = {
                        show: true,
                        alert: "success",
                        title: this.$t('global.common.update_submit', { defaultValue: '确认' }),
                        params: { ids: params },
                        ajaxRequest: HttpBatchConfirmInboundOrder,
                    };
                    break;
                case 'export':
                    this.handleWebfs(
                        HttpExportInboundOrder, this.interceptRequest(JSON.parse(JSON.stringify(this.formData))),
                        { executor: 'request', download: true }
                    );
                    break;
                case 'import':
                    this.operate = {
                        show: true,
                        title: this.$t('fbb.inbound_import_data', { defaultValue: '导入数据' }),
                        width: 460,
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_FBB+ "/api/v2/InboundOrder/importOrder",
                        name: "multipartFile",
                        component: "compUpload",
                        download: () => {
                            this.handleWebfs("/static/template/import_inboundOrder.xls", {}, {
                                executor: 'download',
                                type: 'url'
                            });
                        },
                        on:{
                            "on-success":()=>{
                                this.$emit('on-close')
                            }
                        }
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, inboundOrderStatus } = row;
            return [{
                label: this.$t('global.common.operation_see', { defaultValue: '查看' }),
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                show: inboundOrderStatus == 0 && this.handleAuth('fbb.inboundorder.edit'),
                params: id,
                operate: 'edit',
            }, {
                label: this.$t('global.common.update_submit', { defaultValue: '确认' }),
                show: (inboundOrderStatus != 70 && inboundOrderStatus != 90) && this.handleAuth('fbb.inboundorder.edit'),
                params: id,
                operate: 'confirm',
            }, {
                label: this.$t('global.common.operation_cancel', { defaultValue: '取消' }),
                show: (inboundOrderStatus != 70 && inboundOrderStatus != 90) && this.handleAuth('fbb.inboundorder.edit'),
                params: id,
                operate: 'cancel'
            }]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getSelfmanageorgList','getBillcusAndFbaWareList','getUserManageWarehouseList', 'getCusproductList', 'getBillcusWareList']),
        ToolsData() {
            return [{
                name: this.$t('global.common.add', { defaultValue: "添加" }),
                operate: "add",
                theme: "primary",
                show: this.handleAuth('fbb.inboundorder.edit')
            }, {
                name: this.$t('global.common.export', { defaultValue: "导出" }),
                operate: "export",
                show: this.handleAuth('fbb.inboundorder.export')
            },{
                name: this.$t('fbb.alloment.muti_import', { defaultValue: "批量导入" }),
                operate: "import",
                more:true,
                
            },{
                name: this.$t('fbb.alloment.muti_confirm', { defaultValue: "批量确认" }),
                operate: "batchConfirm",
                more:true,
                batch:true,
            }]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.inbound.order_order_no', { defaultValue: "入库单号" }),
                    key: 'EQ_inboundOrderNo',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('global.common.source_number', { defaultValue: "来源单号" }),
                    key: 'EQ_sourceNo',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('fbb.inbound.storage_number', { defaultValue: "入库计划单号" }),
                    key: 'EQ_inboundPlanOrderNo',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    tag: 'vSelect',
                    show: true,
                    key: 'EQ_orgWarehouseCode',
                    options: this.getUserManageWarehouseList,
                    props: {
                        filterable: true,
                    }
                },
                {
                    label: this.$t('global.common.project', { defaultValue: "项目" }),
                    key: 'EQ_lineId',
                    tag: 'vSelect',
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('global.common.status', { defaultValue: "状态" }),
                    key: 'EQ_inboundOrderStatus',
                    tag: 'vSelect',
                    options: this.getOrderStatus,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('global.common.organization', { defaultValue: "组织" }),
                    key: 'EQ_organizationId',
                    tag: 'vSelect',
                    options: this.getSelfmanageorgList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: this.$t('global.common.updatedAt', { defaultValue: "更新时间" }),
                    key: 'BT_updatedAt',
                    tag: 'vDatepicker',
                    props: {
                        format: 'yy-mm-dd ~ yy-mm-dd',
                        confirm: false,
                    },
                    style: "width:250px",
                },
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: this.$t('global.common.actions', { defaultValue: '操作' }),
                    maxWidth: 90,
                    render: this.getOperateNodes
                }, {
                    title: this.$t('global.common.cusorg', { defaultValue: '客户组织' }),
                    key: 'orgName',
                }, {
                    title: this.$t('fbb.inbound.order_order_no', { defaultValue: '入库单号' }),
                    key: 'inboundOrderNo',
                    render: (h, { row }) => {
                        return <a class="color-link" onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.inboundOrderNo}</a>
                    }
                }, {
                    title: this.$t('global.common.source_number', { defaultValue: '来源单号' }),
                    key: 'sourceNo',
                }, {
                    title: this.$t('fbb.inbound.storage_number', { defaultValue: '入库计划单号' }),
                    key: 'inboundPlanOrderNo',
                }, {
                    title: this.$t('global.common.status', { defaultValue: '状态' }),
                    key: 'inboundOrderStatus',
                    render: (h, { row }) => {
                        const status = row.inboundOrderStatus;
                        const { theme = 'default', label } = this.getOrderStatus.find(function (item) {
                            return item.value == status
                        }) || {};
                        return <vButton ghost theme={theme} size="small" class="cursor-not width-60">{label}</vButton>
                    }
                }, {
                    title: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key: 'orgWarehouseCode',
                }, {
                    title: this.$t('global.common.project', { defaultValue: '项目' }),
                    key: 'lineName'
                }, {
                    title: this.$t('global.common.updatedAt', { defaultValue: '更新时间' }),
                    key: 'updatedAt',
                }];
        },
    },
};




